import './InfoBreakout.css'
import Item from './Item'
import { FormattedNumber } from './financialsModel'

export type Props = {
  title: string
  data: FormattedNumber[]
}

export default function InfoBreakout({ title, data }: Props) {
  const items = data.map(({ amount, type, style }, index) => {
    return <div key={index} className="financial-info-breakout-item"><Item amount={amount} type={type} style={style} /></div>
  })

  return (
    <div className="financial-info-breakout">
      <h3>{title}</h3>
      {items}
    </div>
  );
}
